export function colourSlider() {
    $(".slider-for").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: false,
        draggable: false,
        fade: true,
        asNavFor: ".slider-nav",
        centerMode: true,
        dots: false
    });

    let $sliderNav = $(".slider-nav");
    $sliderNav.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        mobileFirst: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    vertical: true,
                    verticalSwiping: true,
                }
            },
            // {
            //     breakpoint: 767,
            //     settings: {
            //         slidesToShow: 4
            //     }
            // },
            {
                breakpoint: 319,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    }).on("afterChange", () => {
        let $curSlide = $sliderNav.find('.slick-current');
        if ($('body.single-products .product-colors').length > 0) {
            let $this = $($curSlide[0]).find('.slide');
            setActiveSlide($this);
        }
    });

    function setActiveSlide($this) {
        let color = $this.attr('data-color');
        let url = window.location.href.split('?');
        window.history.pushState(null, null, url[0] + '?color_product=' + color);

        $maskSlider.find('.slide').removeClass('active');
        $maskSlider.find('.slide').each(function () {
            let $this = $(this);
            if ($this.attr('data-color') === color) {
                $this.addClass('active');
            }
        });

        $maskEffectSlider.find('.slide').each(function (index) {
            let $this = $(this);
            if ($this.attr('data-color') === color) {
                $maskEffectSlider.slick('slickGoTo', index, false);
            }
        });

        //Show description block by product color
        let $colorsDesc = $('.holder-colors-desc').find('.color-desc');
        $colorsDesc.removeClass('active');
        $colorsDesc.each(function () {
            let $this = $(this);
            if ($this.attr('data-color') === color) {
                $this.addClass('active');
            }
        });
    }

    // $maskSlider.find('.slide').click(function () {
    //     let $this = $(this);
    //     let color = $this.attr('data-color');
    //
    //     $sliderNav.find('.slide').each(function () {
    //         let $this = $(this);
    //         if ($this.attr('data-color') === color) {
    //             $this.trigger('click');
    //         }
    //     });
    // });
    //
    // window.addEventListener("load", () => {
    //     //Set active slide for SliderNav
    //     if (colorParam) {
    //         $sliderNav.find('.slide').each(function () {
    //             let $this = $(this);
    //             if ($this.attr('data-color') === colorParam) {
    //                 $this.trigger('click')
    //             }
    //         });
    //     }
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/images-colour.js